<template>
  <!-- <auth-layout :fiftyPercentWidth="true"> -->
  <signup-authentication />
  <!-- </auth-layout> -->
</template>

<script>
// import AuthLayout from "@/components/Auth/Authlayout/AuthLayout";
import SignupAuthentication from "@/components/Auth/Home/SignupAuthentication";
export default {
  components: {
    // AuthLayout,
    SignupAuthentication,
  },
};
</script>

<style></style>
